import React from "react";
import { Carousel } from "react-bootstrap";
import { arrayOf, object } from "prop-types";
import "./gallery-carousel.scss";

const GalleryCarousel = ({ photos }) => {
  return (
    <Carousel id="gallery-carousel">
      {photos.map(x => (
        <Carousel.Item key={x.fields.file.url}>
          <img className="d-block" src={x.fields.file.url} alt="Gallery Item" />
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

GalleryCarousel.propTypes = {
  photos: arrayOf(object).isRequired
};

export default GalleryCarousel;
